import React from 'react';
import { Box, Checkbox, SimpleGrid, Text } from '@chakra-ui/react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { InputForm } from '../../../../../../components/inputs/forms/InputForm';
import { TextAreaInputForm } from '../../../../../../components/inputs/forms/TextAreaInputForm';
import { MunicipioBusca } from '../../shared/MunicipioBusca';
import { PaisBusca } from '../../shared/PaisBusca';
import { ServicoBusca } from '../../shared/ServicoBusca';
import { C } from '../../shared/ui';
import { FormSection } from './FormSection';
import { IbsCbsCampos } from './IbsCbsCampos';

export function ServicoSection({
  isDisabled,
  editado,
  emitenteId,
}: {
  isDisabled?: boolean;
  editado: (campo: string) => boolean;
  emitenteId?: number | null;
}) {
  const { control, setValue } = useFormContext();
  const descricao = (useWatch({ name: 'descricao' }) as string) ?? '';
  const exterior = !!useWatch({ name: 'local_prestacao_exterior' });
  // Campo que difere do padrão do emitente ganha o aviso: vai para a auditoria (RF18).
  const marca = (campo: string) =>
    editado(campo) ? { helper: 'editado', helperColor: C.brand700 } : {};

  return (
    <FormSection n={3} title="Serviço" subtitle="Padrões do emitente já preenchidos">
      <SimpleGrid columns={{ base: 1, md: 2 }} columnGap={4}>
        <InputForm
          name="competencia"
          label="Competência"
          type="date"
          isRequired
          isDisabled={isDisabled}
          {...marca('competencia')}
        />
        <Box>
          {exterior ? (
            <PaisBusca
              name="local_prestacao_pais"
              label="País da prestação"
              isRequired
              isDisabled={isDisabled}
              controlMb={2}
            />
          ) : (
            <MunicipioBusca
              name="local_prestacao_ibge"
              label="Local da prestação"
              isRequired
              isDisabled={isDisabled}
              controlMb={2}
              {...marca('local_prestacao_ibge')}
            />
          )}
          <Controller
            control={control}
            name="local_prestacao_exterior"
            render={({ field: { value, onChange } }) => (
              <Checkbox
                mb={5}
                size="sm"
                isChecked={!!value}
                isDisabled={isDisabled}
                onChange={e => onChange(e.target.checked)}
              >
                <Text fontSize="13px" color={C.ink}>
                  Serviço prestado no exterior
                </Text>
              </Checkbox>
            )}
          />
        </Box>
      </SimpleGrid>
      <ServicoBusca
        name="c_trib_nac"
        label="Código de tributação nacional"
        emitenteId={emitenteId}
        isRequired
        isDisabled={isDisabled}
        onTrocar={() =>
          // NBS e IBS/CBS são do serviço: o novo traz os dele (Anexo VIII).
          ['c_nbs', 'c_ind_op', 'c_class_trib'].forEach(campo =>
            setValue(campo, '', { shouldDirty: true }),
          )
        }
        {...marca('c_trib_nac')}
      />
      <IbsCbsCampos isDisabled={isDisabled} />
      <TextAreaInputForm
        name="descricao"
        label="Descrição do serviço"
        isRequired
        rows={3}
        controlMb={0}
        isDisabled={isDisabled}
      />
      <Text fontSize="12px" mt="6px" color={editado('descricao') ? C.brand700 : C.subtle}>
        {descricao.length}/2000 caracteres · sai assim no DANFSe
        {editado('descricao') ? ' · editado' : ''}
      </Text>
    </FormSection>
  );
}
